// extracted by mini-css-extract-plugin
module.exports =  {"btn":"a10a3f92e9--btn--mZdZU","btn--dark":"a10a3f92e9--btn--dark--MJfDu","icon":"a10a3f92e9--icon--P0fay","arrow":"a10a3f92e9--arrow--tHaho","texts":"a10a3f92e9--texts--dbl9D"};